<script>
import { saveSearchResults } from '@state/helpers'
export default {
  props: {
    crumbs: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    this.crumbFun()
  },
  methods: {
    ...saveSearchResults,
    crumbFun() {
      let pathArray = this.$route.path.split('/')
      pathArray.shift()
      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push({
          path: path,
          to: breadcrumbArray[idx - 1]
            ? '/' + breadcrumbArray[idx - 1].path + '/' + path
            : '/' + path,
          text:
            this.$route.matched.find((val) => {
              return val
            }).meta.breadCrumb || path,
        })
        return breadcrumbArray
      }, [])
      return breadcrumbs
    },
    setStatus(text) {
      if(text === 'Usage Report') {
        this.setSummaryStatus(true)
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="body--wrapper mt-1 m-auto container py-3 px-0">
      <b-breadcrumb class="mb-0 bg-transparent py-1 pl-0 ml-0">
        <b-breadcrumb-item
          v-for="(item, i) in crumbs"
          :key="i"
          :active="item.active"
          :to="item.to"
        >
          <BaseIcon v-if="!i" name="home"></BaseIcon>
          <span v-else @click="setStatus(item.text)" v-html="item.text"></span
        ></b-breadcrumb-item>
      </b-breadcrumb>
    </div>
  </div>
</template>
